import {NormalizedBorderProp, UnnormalizedBorderProp, VisualFn} from "@yosmanyga/core-style";
import type {ThemeVariablesType} from "../../variables";

const normalizeBorder = (
    border: UnnormalizedBorderProp | undefined,
    theme: {variables: ThemeVariablesType}
): NormalizedBorderProp | undefined => {
    const normalizedBorder = VisualFn.normalizeBorder(border);

    if (
        typeof normalizedBorder === 'undefined'
    ) {
        return normalizedBorder
    }

    if (
        typeof normalizedBorder.top !== 'undefined'
        && typeof normalizedBorder.top.width !== 'undefined'
    ) {
        normalizedBorder.top.width = theme.variables.widthing(normalizedBorder.top.width)
    }

    if (
        typeof normalizedBorder.bottom !== 'undefined'
        && typeof normalizedBorder.bottom.width !== 'undefined'
    ) {
        normalizedBorder.bottom.width = theme.variables.widthing(normalizedBorder.bottom.width)
    }

    if (
        typeof normalizedBorder.left !== 'undefined'
        && typeof normalizedBorder.left.width !== 'undefined'
    ) {
        normalizedBorder.left.width = theme.variables.widthing(normalizedBorder.left.width)
    }

    if (
        typeof normalizedBorder.right !== 'undefined'
        && typeof normalizedBorder.right.width !== 'undefined'
    ) {
        normalizedBorder.right.width = theme.variables.widthing(normalizedBorder.right.width)
    }

    return normalizedBorder
}

export {
    normalizeBorder,
}